import { required } from "vuelidate/lib/validators";
 
const StrIsoDuzelticiFaaliyet = {
  data() {
    return {
      StrIsoDuzelticiFaaliyetData: {
        No: null,
        Acilistarih: null,
        Acanid: null,
        Acanbirimid: null,
        Tespitsekliid: null,
        Uyumsuzluktanim: null,
        Acilisonay: null,
        Yapiacakduzelticifaaliyet: null,
        Ongorulenbitirmetarih: null,
        Onaylayanid: null,
        Kanit: [],
        Bitirmetarih: null,
        Kapanisonay: null,
        Not: null,
      },
      FormDataType: { 
        No: { FieldName: "No", Field: "textarea", FieldTitle: "No", FieldType: "text", Disabled:"disabled" },
        Acanbirimid: { FieldName: "Acanbirimid", Field: "combobox", FieldTitle: "Açılan Birim", ComboDataArray: [] },
        Tespitsekliid: { FieldName: "Tespitsekliid", Field: "combobox", FieldTitle: "Tespit Şekli", ComboDataArray: [] },
        Uyumsuzluktanim: { FieldName: "Uyumsuzluktanim", Field: "textarea", FieldTitle: "Uygunsuzluk  Tanım" },
        Yapiacakduzelticifaaliyet: { FieldName: "Yapiacakduzelticifaaliyet", Field: "textarea", FieldTitle: "Yapılacak Düzeltici Faaliyet" },
        Ongorulenbitirmetarih: { FieldName: "Ongorulenbitirmetarih", Field: "date", FieldTitle: "Öngörülen Bitirme Tarihi" },
        Kanit: { FieldName: "Kanit", Field: "textarea", FieldTitle: "Kanıt" },
        Bitirmetarih: { FieldName: "Bitirmetarih", Field: "date", FieldTitle: "Bitirme Tarihi" },  
        Not: { FieldName: "Not", Field: "textarea", FieldTitle: "Not", FieldType: "text",  },
      }, 
    }
  },
  validations: {
    FormData: {
      No: { required },
      Acanbirimid: { required },
      Tespitsekliid: { required },
      Uyumsuzluktanim: { required },
      Yapiacakduzelticifaaliyet: {},
      Ongorulenbitirmetarih: {},
      Kanit: {},
      Bitirmetarih: {},
      Not: {}
    },
    Filter:{ 
      Acanid: {},
      Tespitsekliid: {},
      Acanbirimid: {},
      Acilisonay: {},
      Kapanisonay: {},
      No: {},
      Acilistarihbas: {},
      Acilistarihbit: {},
      Bitirmetarihbas: {},
      Bitirmetarihbit: {}
    }
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999"
    }
    this.ActionsGet({ "Service": "OBirim", "Page": Page }).then((res) => { 
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Acanbirimid.ComboDataArray.push({ Id: res.Data[i].Id, Value: res.Data[i].BirimAdi, Striyilestirmemail:res.Data[i].Striyilestirmemail })
      }
    });
    this.ActionsSabitGet(273).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Tespitsekliid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value}) 
        }    
    });
     

  }
}
export default StrIsoDuzelticiFaaliyet